export * from './SettingsAltIcon';
